import { forwardRef, type ComponentProps } from 'react';
import { cn } from '@/lib/utils';

const STEPS = Array.from({ length: 96 }, (_, i) => `${String(Math.floor(i / 4)).padStart(2, '0')}:${String((i % 4) * 15).padStart(2, '0')}`);

/**
 * Seletor de horário em 24 h (passos de 15 min). Substitui `<input type="time">`,
 * cujo formato muda com o idioma do navegador (AM/PM) e não cabe em telas pequenas.
 */
export const TimeSelect = forwardRef<HTMLSelectElement, Omit<ComponentProps<'select'>, 'children'> & { value: string }>(
  ({ value, className, ...props }, ref) => {
    const options = STEPS.includes(value) || !value ? STEPS : [...STEPS, value].sort();
    return (
      <select
        ref={ref}
        value={value}
        className={cn(
          'tabular h-9 rounded-md border border-input bg-transparent px-2.5 text-sm shadow-xs outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {options.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
    );
  },
);
TimeSelect.displayName = 'TimeSelect';
